'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const styleEncapsulation = require('@zapier/style-encapsulation');

const Styles = styleEncapsulation.labelStyles("FormLabelRequiredText", {
  root: react.css`
    ${theme_Typography.Typography.SmallPrint1}
    color: var(--zds-text-default, ${theme_Colors.Colors.GrayWarm9});
    text-transform: lowercase;

    &::before {
      content: '(';
    }

    &::after {
      content: ')';
    }

    &[data-state='disabled'] {
      color: var(--zds-text-weakest, ${theme_Colors.Colors.GrayWarm5});
    }
  `
});
const FormLabelRequiredText = ({ children = "Required", isDisabled = false }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    react.jsx("span", { "aria-hidden": "true", css: Styles.root, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true }, children)
  );
};

exports.FormLabelRequiredText = FormLabelRequiredText;
//# sourceMappingURL=FormLabelRequiredText.cjs.js.map
